import rgbHex from 'rgb-hex'
import colors from '../../../config/colors.json'

function getXPProgress(totalXP, xpRequired) {
	let levelRequirements = [xpRequired]

	for (let i = 0; i < levelRequirements.length; i++) {
		if (totalXP < levelRequirements[i]) {
			const prevReq = i === 0 ? 0 : levelRequirements[i - 1]
			const nextReq = levelRequirements[i]
			return ((totalXP - prevReq) / (nextReq - prevReq)) * 100
		}
	}
	// If XP meets or exceeds last requirement = max level
	return 100
}

export function VikingSagaProgress({ xp, xpRequired, color, icon, useBackground = false }) {
	//jeannes xp is just an integer an has no limits
	//all the level ups are just statemodel bools

	let mainColor = rgbHex(colors[color]?.mainColor)

	let background = useBackground ? 'url("/Empty_Background.png")' : 'url("/sheepCounter/background.png")'

	return (
		<div
			className={`border-solid border flex flex-col justify-center w-[40px] h-[40px]`}
			style={{
				borderColor: 'var(--main-color)',
				backgroundImage: background,
			}}>
			<div className="flex flex-row w-[38px] justify-center">
				<img src={icon} className="w-[33px] h-[33px]" alt="" />
			</div>
			<div className="w-[38px] h-[8px] flex flex-row border-solid border border-[#5E6989]">
				<div
					style={{
						backgroundColor: `#${mainColor}`,
						flexBasis: `${getXPProgress(xp, xpRequired)}%`,
					}}></div>
				<div
					style={{
						backgroundColor: '#000000',
						flexBasis: `${100 - getXPProgress(xp, xpRequired)}%`,
					}}></div>
			</div>
		</div>
	)
}
